import { gql } from 'apollo-angular';

export const LIST_VENDORS = gql`
  query vendors($search: String) {
    vendors(search: $search) {
      id
      branchId
      branchData {
        branchName
      }
      vendorName
      contactPerson
      email
      phone
      address
      trn
      currency
      openingBalance
    }
  }
`;

export const FETCH_VENDOR = gql`
  query vendor($id: Int!) {
    vendor(id: $id) {
      id
    branchId
    branchData {
      id
      branchName
      address
    }
    vendorName
    contactPerson
    email
    phone
    address
    trn
    currency
    openingBalance
    }
  }
`;
